"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfShiftProposalCreateDto = instanceOfShiftProposalCreateDto;
exports.ShiftProposalCreateDtoFromJSON = ShiftProposalCreateDtoFromJSON;
exports.ShiftProposalCreateDtoFromJSONTyped = ShiftProposalCreateDtoFromJSONTyped;
exports.ShiftProposalCreateDtoToJSON = ShiftProposalCreateDtoToJSON;
exports.ShiftProposalCreateDtoToJSONTyped = ShiftProposalCreateDtoToJSONTyped;
/**
 * Check if a given object implements the ShiftProposalCreateDto interface.
 */
function instanceOfShiftProposalCreateDto(value) {
    if (!('shiftId' in value) || value['shiftId'] === undefined)
        return false;
    if (!('nurseProfileId' in value) || value['nurseProfileId'] === undefined)
        return false;
    if (!('comment' in value) || value['comment'] === undefined)
        return false;
    return true;
}
function ShiftProposalCreateDtoFromJSON(json) {
    return ShiftProposalCreateDtoFromJSONTyped(json, false);
}
function ShiftProposalCreateDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'shiftId': json['shiftId'],
        'nurseProfileId': json['nurseProfileId'],
        'proposedDate': json['proposedDate'] == null ? undefined : json['proposedDate'],
        'proposedStartTime': json['proposedStartTime'] == null ? undefined : json['proposedStartTime'],
        'proposedEndTime': json['proposedEndTime'] == null ? undefined : json['proposedEndTime'],
        'proposedPayRate': json['proposedPayRate'] == null ? undefined : json['proposedPayRate'],
        'stipendChangeRequested': json['stipendChangeRequested'] == null ? undefined : json['stipendChangeRequested'],
        'comment': json['comment'],
    };
}
function ShiftProposalCreateDtoToJSON(json) {
    return ShiftProposalCreateDtoToJSONTyped(json, false);
}
function ShiftProposalCreateDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'shiftId': value['shiftId'],
        'nurseProfileId': value['nurseProfileId'],
        'proposedDate': value['proposedDate'],
        'proposedStartTime': value['proposedStartTime'],
        'proposedEndTime': value['proposedEndTime'],
        'proposedPayRate': value['proposedPayRate'],
        'stipendChangeRequested': value['stipendChangeRequested'],
        'comment': value['comment'],
    };
}
//# sourceMappingURL=ShiftProposalCreateDto.js.map